import styled from "styled-components";
import { ReactComponent as ArrowLeftIcon } from "../../assets/icons/arrow-left.svg";
import useNavigateThrottle from "../../hooks/useNavigateThrottle";

interface Props {
  handleBack?: () => void;
}

const EditWatchListAppHeader = ({ handleBack }: Props) => {
  const navigate = useNavigateThrottle();

  const StyledAppHeader = styled.div`
    display: flex;
    align-items: center;
    top: 0;
    width: 100vw;
    min-height: calc(44px + constant(safe-area-inset-top));
    min-height: calc(44px + env(safe-area-inset-top));
    padding-top: calc(18px + constant(safe-area-inset-top));
    padding-top: calc(18px + env(safe-area-inset-top));
    padding-right: 24px;
    padding-bottom: 18px;
    padding-left: 24px;
    background-color: var(--background-color-primary);
    user-select: none;
    z-index: 99;
  `;

  const StyledAppHeaderStartContainer = styled.div`
    min-width: 24px;
    flex-shrink: 0;
    line-height: 1;
  `;

  const StyledAppHeaderTitle = styled.div`
    flex-grow: 1;
    margin-left: 16px;
    margin-right: 16px;
    font-weight: var(--font-weight-semi-bold);
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  `;

  return (
    <StyledAppHeader>
      <StyledAppHeaderStartContainer>
        <ArrowLeftIcon
          id="left-arrow-for-back"
          className="mbb-icon"
          onClick={() => {
            if (handleBack) {
              handleBack();
            } else {
              navigate(-1);
            }
          }}
        />
      </StyledAppHeaderStartContainer>
      <StyledAppHeaderTitle>Edit Watchlist</StyledAppHeaderTitle>
    </StyledAppHeader>
  );
};

export default EditWatchListAppHeader;
